<template>
  <OnboardingLayout
    :title="$t('onboarding.networks.title')"
    :subtitle="$t('onboarding.networks.subtitle')"
    :can-proceed="canProceed"
    @next="handleNext"
    @skip="handleSkip"
  >
    <NetworkSelector v-model="selectedNetworks" :networks="availableNetworks" />
  </OnboardingLayout>
</template>

<script>
import { mapMutations } from 'vuex';
import OnboardingLayout from '../OnboardingLayout.vue';
import NetworkSelector from '../shared/NetworkSelector.vue';
import { clearOnboardingFlags } from '../utils/onboardingPersistence';

export default {
  name: 'StepNetworks',

  components: {
    OnboardingLayout,
    NetworkSelector
  },

  data() {
    return {
      selectedNetworks: []
    }
  },

  computed: {
    // NOTE: Do NOT use mapState('onboarding', ['selectedNetworks']) here.
    // In Vue 2, data() takes priority over computed, so the mapState would be shadowed.
    // Instead, we use the local data property and sync it from/to the store manually.

    availableNetworks() {
      return [
        {
          id: 'facebook',
          name: 'Facebook',
          icon: require('@/assets/img/iconsNetwork/ico-facebook-2x.png'),
          disabled: false
        },
        {
          id: 'instagram',
          name: 'Instagram',
          icon: require('@/assets/img/iconsNetwork/ico-instagram-2x.png'),
          disabled: false
        },
        {
          id: 'linkedin',
          name: 'LinkedIn',
          icon: require('@/assets/img/iconsNetwork/ico-linkedin-2x.png'),
          disabled: false
        },
        {
          id: 'threads',
          name: 'Threads',
          icon: require('@/assets/img/iconsNetwork/ico-threads-2x.png'),
          disabled: false
        },
        {
          id: 'twitter',
          name: 'X',
          icon: require('@/assets/img/iconsNetwork/ico-twitter-2x.png'),
          disabled: false
        },
        {
          id: 'tiktok',
          name: 'TikTok',
          icon: require('@/assets/img/iconsNetwork/ico-tiktok-2x.png'),
          disabled: false
        },
        {
          id: 'youtube',
          name: 'YouTube',
          icon: require('@/assets/img/iconsNetwork/ico-youtube-2x.png'),
          disabled: false
        },
        {
          id: 'bluesky',
          name: 'Bluesky',
          icon: require('@/assets/img/iconsNetwork/ico-bluesky-2x.png'),
          disabled: false
        },
        {
          id: 'google',
          name: 'Business Profile',
          icon: require('@/assets/img/iconsNetwork/ico-google-2x.png'),
          disabled: false
        },
        {
          id: 'pinterest',
          name: 'Pinterest',
          icon: require('@/assets/img/iconsNetwork/ico-pinterest-2x.png'),
          disabled: false
        }
      ]
    },

    canProceed() {
      return this.selectedNetworks.length > 0
    }
  },

  mounted() {
    console.log('=== [StepNetworks] MOUNTED ===')
    console.log('[StepNetworks] Store state:', {
      selectedNetworks: this.$store.state.onboarding.selectedNetworks,
      selectedFeatures: this.$store.state.onboarding.selectedFeatures
    })
    console.log('[StepNetworks] LocalStorage flags:', {
      onboarding_mode: localStorage.getItem('onboarding_mode'),
      current_network: localStorage.getItem('onboarding_current_network'),
      current_index: localStorage.getItem('onboarding_current_index')
    })
    // Mark user as actively in onboarding
    this.$store.commit('onboarding/SET_IS_ONBOARDING', true)
    // Restore state from store
    this.selectedNetworks = [...this.$store.state.onboarding.selectedNetworks]
    console.log('[StepNetworks] Restored selected networks:', this.selectedNetworks)
  },

  methods: {
    ...mapMutations('onboarding', ['SET_NETWORKS', 'SET_STEP']),

    handleNext() {
      if (!this.canProceed) {
        console.log('[StepNetworks] Cannot proceed - no networks selected')
        return
      }

      console.log('[StepNetworks] handleNext - Selected networks:', this.selectedNetworks)
      // Save to store
      this.SET_NETWORKS(this.selectedNetworks)
      this.SET_STEP(2)
      console.log('[StepNetworks] Store updated, current state:', this.$store.state.onboarding.selectedNetworks)

      // Navigate to next step
      console.log('[StepNetworks] Navigating to onboarding-features')
      this.$router.push({ name: 'onboarding-features' })
    },

    handleSkip() {
      console.log('[StepNetworks] User clicked skip - abandoning onboarding')
      // Reset all onboarding store state (also sets isOnboarding = false)
      this.$store.commit('onboarding/RESET_ONBOARDING')
      // Mark onboarding as skipped to prevent redirect loop
      localStorage.setItem('onboardingSkipped', 'true')
      // Clean up onboarding flags and redirect to dashboard
      this.clearOnboardingFlags()
      console.log('[StepNetworks] Redirecting to dashboard')
      this.$router.push({ name: 'dash' })
    },

    clearOnboardingFlags() {
      clearOnboardingFlags()
    }
  }
}
</script>

<style scoped lang="scss">
// No additional styles needed, everything is in child components
</style>
